import { Component, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.scss']
})
export class ImageCropperComponent implements OnInit,OnDestroy {
  imageChangedEvent: any = '';
  croppedImage: any = '';
  public assetList: any[] = [];
  canvasRotation = 0;
  _apiSubscription: Subscription
  rotation = 0;
  scale = 1;
  showCropper = false;
  containWithinAspectRatio = false;
  transform: { scale?: number;
    rotate?: number;
    flipH?: boolean;
    flipV?: boolean;} = {};
  isCropImageSelected:Boolean=false;
  constructor(@Inject(MAT_DIALOG_DATA) public parentdata: any,private activemodal: MatDialogRef<ImageCropperComponent>, private _apiService: ApiService, private loaderservice: LoaderServiceService, private _ngZone: NgZone) { 

    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log('Response', res);
      if (res.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        console.log(res.result.url);
        this.assetList = []
        this._ngZone.run(() => {
          this.assetList.push({
          "entity_hash": this.parentdata.data.hashId,
          "media_url": res.result?.url,
          "thumb_media_url": res.result?.thumbnail,
          "asset_usage_type": "3",
          "is_logo": "1",
          "asset_type": 1
          });
          console.log(this.assetList);
        });
        setTimeout(() => {
          this._apiService.uploadEntityMedia(this.assetList[0])
        }, 3000);
        // this.buisnessPromotionData.imgUrl = res.result?.url;
      }
      if (res.responseType === SM_CONSTANTS.RESULT_API_UPLOAD_ENTITY_MEDIA) {
        if (res.result) { 
          this.loaderservice.showLoader = false
          this.activemodal.close({msg: 'success'})
        }
       
      }
    })


  }

  ngOnInit(): void {
    this.imageChangedEvent = this.parentdata.file
    console.log(this.imageChangedEvent);
    
  }
  imageCropped(event: ImageCroppedEvent) {
    console.log("Image cropped: ",event);
    this.croppedImage = event.base64;
    console.log(event, this.base64ToFile(event.base64!));
}

imageLoaded() {
    this.showCropper = true;
    console.log('Image loaded');
}

cropperReady(sourceImageDimensions: any) {
    console.log('Cropper ready', sourceImageDimensions);
}

loadImageFailed() {
    console.log('Load failed');
}
  rotateLeft() {
    this.canvasRotation--;
    this.flipAfterRotate();
}

rotateRight() {
    this.canvasRotation++;
    this.flipAfterRotate();
}
zoomOut() {
  this.scale -= .1;
  this.transform = {
      ...this.transform,
      scale: this.scale
  };
}

zoomIn() {
  this.scale += .1;
  this.transform = {
      ...this.transform,
      scale: this.scale
  };
}
private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
        ...this.transform,
        flipH: flippedV,
        flipV: flippedH
    };
}

base64ToFile(base64Image: string): Blob {
  const split = base64Image.split(',');
  const type = split[0].replace('data:', '').replace(';base64', '');
  const byteString = atob(split[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i += 1) {
      ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], {type});
}
onSave(){
  // let formData: FormData = new FormData();
  // formData.append('recfile', this.croppedImage);
  // this._apiService.uploadAssets(formData, 1);

  const croppedBase64 = this.croppedImage; // Get the cropped base64 image
  const contentType = this.imageChangedEvent.target.files[0].type; // Adjust this to match the image format you expect

  // Convert the base64 image to a Blob
  const croppedFileBlob = this.base64ToBlob(croppedBase64, contentType);

  // Create FormData and append the Blob
  const formData: FormData = new FormData();
  
    const originalFile = this.imageChangedEvent.target.files[0];
    let fileName = originalFile.name;

    if (fileName.includes(' ')) {
      fileName = fileName.replace(/\s+/g, '_');
    }

    
    


  formData.append('recfile', croppedFileBlob, fileName); // You can give the file a name here

  // Send to the backend API
  this.loaderservice.showLoader = true
  this._apiService.uploadAssets(formData, 1);
}

base64ToBlob(base64Data: string, contentType: string = '', sliceSize: number = 512): Blob {
  const byteCharacters = atob(base64Data.split(',')[1]); // remove base64 header
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
}

ngOnDestroy(): void {
  this._apiSubscription.unsubscribe()
}

}
